export const LOGGER_DOMAIN_NAME = '@effector-logger';
export function createName(composite) {
    return composite.path.filter((name) => name !== LOGGER_DOMAIN_NAME).join('/');
}
export function getPath(unit) {
    var _a, _b, _c;
    return (_c = (_b = (_a = unit.defaultConfig) === null || _a === void 0 ? void 0 : _a.loc) === null || _b === void 0 ? void 0 : _b.file) !== null && _c !== void 0 ? _c : ' ';
}
